import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './AuthContext';
import keyartImage from './assets/keyart.png';

const root = ReactDOM.createRoot(document.getElementById('root'));

document.documentElement.style.setProperty(
  '--keyart-url',
  `url(${keyartImage})`
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
